import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();
  const rightsLabel = language === 'en' ? 'All rights reserved.' : 'Todos los derechos reservados.';

  return (
    <footer className="bg-gray-900 text-white mt-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-center">
          <p className="text-gray-400 text-sm text-center">
            &copy; {currentYear} <a href="https://www.miwebvacacional.online" target="_blank" rel="noreferrer" className="text-white hover:text-gray-200 underline underline-offset-4">Mi Web Vacacional</a>. {rightsLabel}
          </p>
        </div>
      </div>
    </footer>
  );
};
